module.exports = __webpack_public_path__ + "static/img/Picture2.916cd02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/191017/Picture2.jpg
// module id = 61kO
// module chunks = 1